export default __webpack_public_path__ + "static/media/p2-8.4bee19ce.png";